module.exports = __webpack_public_path__ + "static/media/slide2.fda5f825.jpg";